export default __webpack_public_path__ + "static/media/logo-aftim-dark.467eecf5.png";